export const INCOME_STATEMENT_METRICS = [
	'Date',
	'Revenue',
	'Period',
	'Cik',
	'Filling Date',
	'Accepted Date',
	'Calendar Year',
	'Cost Of Revenue',
	'Gross Profit',
	'Gross Profit Ratio',
	'Research And Development Expenses',
	'General And Administrative Expenses',
	'Selling And Marketing Expenses',
	'Other Expenses',
	'Operating Expenses',
	'Cost And Expenses',
	'Interest Expense',
	'Depreciation And Amortization',
	'EBITDA',
	'EBITDA Ratio',
	'Operating Income',
	'Operating Income Ratio',
	'Total Other Income Expenses Net',
	'Income Before Tax',
	'Income Before Tax Ratio',
	'Income Tax Expense',
	'Interest Income',
	'Net Income',
	'Net Income Ratio',
	'EPS',
	'EPS Diluted',
	'Weighted Average Shares Outstanding',
	'Weighted Average Shares Outstanding Diluted'
]

export const STATEMENT_OF_CASH_FLOWS_METRICS = [
	'Date',
	'Deferred Income Tax',
	'Depreciation and Amortization',
	'Period',
	'Cik',
	'Filling Date',
	'Accepted Date',
	'Calendar Year',
	'Stock Based Compensation',
	'Change In Working Capital',
	'Accounts Receivables',
	'Accounts Payables',
	'Other Working Capital',
	'Other Non Cash Items',
	'Net Cash Provided By Operating Activities',
	'Investments In Property Plant And Equipment',
	'Acquisitions Net',
	'Purchases Of Investments',
	'Sales Maturities Of Investments',
	'Other Investing Activities',
	'Net Cash Used For Investing Activities',
	'Debt Repayment',
	'Common Stock Issued',
	'Common Stock Repurchased',
	'Dividends Paid',
	'Other Financing Activities',
	'Net Cash Used Provided By Financing Activities',
	'Effect Of Forex Changes On Cash',
	'Net Change In Cash',
	'Cash At End Of Period',
	'Cash At Beginning Of Period',
	'Operating Cash Flow',
	'Capital Expenditure',
	'Free Cash Flow'
]

export const BALANCE_SHEET_METRICS = [
	'Date',
	'Cash And Cash Equivalents',
	'Period',
	'Cik',
	'Filling Date',
	'Accepted Date',
	'Calendar Year',
	'Short Term Investments',
	'Cash And Short Term Investments',
	'Net Receivables',
	'Inventory',
	'Other Current Assets',
	'Total Current Assets',
	'Property Plant Equipment Net',
	'Goodwill',
	'Intangible Assets',
	'Goodwill And Intangible Assets',
	'Long Term Investments',
	'Tax Assets',
	'Other Non Current Assets',
	'Total Non Current Assets',
	'Other Assets',
	'Total Assets',
	'Account Payables',
	'Short Term Debt',
	'Tax Payables',
	'Deferred Revenue',
	'Other Current Liabilities',
	'Total Current Liabilities',
	'Long Term Debt',
	'Deferred Revenue Non Current',
	'Deferred Tax Liabilities Non Current',
	'Other Non Current Liabilities',
	'Total Non Current Liabilities',
	'Other Liabilities',
	'Total Liabilities',
	'Minority Interest',
	'Total Equity',
	'Total Liabilities and Total Equity',
	'Common Stock',
	'Preferred Stock',
	'Retained Earnings',
	'Accumulated Other Comprehensive Income Loss',
	'Other Total Stockholders Equity',
	'Total Stockholders Equity',
	'Total Liabilities And Stockholders Equity',
	'Total Investments',
	'Total Debt',
	'Net Debt'
]

const RATIOS = [
	'Quick Ratio',
	'Cash Ratio',
	'Operating Profit Margin',
	'Net Profit Margin',
	'Effective Tax Rate',
	'Return On Assets',
	'Return On Equity',
	'Return On Capital Employed',
	'Cash Flow To Debt Ratio',
	'Asset Turnover',
	'Cash Flow Coverage Ratios',
	'Capital Expenditure Coverage Ratio',
	'Dividend Paid And Capex Coverage Ratio',
	'Price Book Value Ratio',
	'Price To Book Ratio',
	'Price To Free Cash Flows Ratio',
	'Price To Operating Cash Flows Ratio',
	'Price Cash Flow Ratio',
	'Price Earnings To Growth Ratio'
]

export const KEY_METRICS = [
	'Date',
	'Revenue Per Share',
	'Operating Cash Flow Per Share',
	'Free Cash Flow Per Share',
	'Cash Per Share',
	'Book Value Per Share',
	'Tangible Book Value Per Share',
	'Book Value GPS',
	'Shareholders Equity Per Share',
	'Interest Debt Per Share',
	'Market Cap',
	'Enterprise Value',
	'PE Ratio',
	'Price To Sales Ratio',
	'POCF Ratio',
	'PFCF Ratio',
	'PB Ratio',
	'PTB Ratio',
	'EV To Sales',
	'Enterprise Value Over EBITDA',
	'EV To Operating Cash Flow',
	'EV To Free Cash Flow',
	'Earnings Yield',
	'Free Cash Flow Yield',
	'Debt To Equity',
	'Debt To Assets',
	'Net Debt To EBITDA',
	'Current Ratio',
	'Interest Coverage',
	'Income Quality',
	'Dividend Yield',
	'Adjusted Dividend',
	'Ex Dividend Date',
	'Record Date',
	'Payment Date',
	'Declaration Date',
	'Payout Ratio',
	'Sales General And Administrative To Revenue',
	'Research And development To Revenue',
	'Intangibles To Total Assets',
	'Capex To Operating Cash Flow',
	'Capex To Revenue',
	'Capex To Depreciation',
	'Stock Based Compensation To Revenue',
	'Graham Number',
	'ROIC',
	'Return On Tangible Assets',
	'Graham Net Net',
	'Working Capital',
	'Tangible Asset Value',
	'Net Current Asset Value',
	'Net Current Asset Value',
	'Average Receivables',
	'Average Payables',
	'Average Inventory',
	'Days Sales Outstanding',
	'Days Payables Outstanding',
	'Days Of Inventory On Hand',
	'Receivables Turnover',
	'Payables Turnover',
	'Inventory Turnover',
	'ROE',
	'Capex Per Share',
	'Estimated Revenue Low',
	'Estimated Revenue High',
	'Estimated Revenue AVG',
	'Estimated EBITDA Low',
	'Estimated EBITDA High',
	'Estimated EBITDA AVG',
	'Estimated EBIT Low',
	'Estimated EBIT High',
	'Estimated EBIT AVG',
	'Estimated Net Income Low',
	'Estimated Net Income High',
	'Estimated Net Income AVG',
	'Estimated SGA Expense Low',
	'Estimated SGA Expense High',
	'Estimated SGA Expense AVG',
	'SGA Expense Growth',
	'Estimated EPS AVG',
	'Estimated EPS High',
	'Estimated EPS Low',
	'Number Analyst Estimated Revenue',
	'Number Analysts Estimated EPS',
	'10 YR Dividend GPS',
	'5 YR Dividend GPS',
	'3 YR Dividend GPS',
	'10 YR Revenue GPS',
	'5 YR Revenue GPS',
	'3 YR Revenue GPS',
	'10 YR Operating Cash Flow GPS',
	'5 YR Operating Cash Flow GPS',
	'3 YR Operating Cash Flow GPS',
	'10 YR Net Income GPS',
	'5 YR Net Income GPS',
	'3 YR Net Income GPS',
	'10 YR Shareholders Equity GPS',
	'5 YR Shareholders Equity GPS',
	'3 YR Shareholders Equity GPS',
	'EPS Diluted Growth',
	'Ebit Growth',
	'Dividends Per Share Growth',
	'RD Expense Growth',
	...RATIOS
]

export const TICKERDATA_METRICS = [
	['Income Statement Metrics', INCOME_STATEMENT_METRICS],
	['Statement of Cash Flows Metrics', STATEMENT_OF_CASH_FLOWS_METRICS],
	['Balance Sheet Data', BALANCE_SHEET_METRICS],
	['Key Metrics', KEY_METRICS]
]

export const TICKERDATALIVE_METRICS = [
	'Price',
	'Beta',
	'Vol Avg',
	'Market Cap',
	'Dividend',
	'365 Day Range',
	'Company Name',
	'Currency',
	'ISIN',
	'CUSIP',
	'Exchange',
	'Exchange Short Name',
	'Industry',
	'Sector',
	'Country',
	'Full Time Employees',
	'Address',
	'IPO Date',
	'Is Actively Trading',
	'Dividend Yield',
	'PE',
	'1D Change',
	'5D Change',
	'1M Change',
	'3M Change',
	'6M Change',
	'YTD Change',
	'1Y Change',
	'3Y Change',
	'5Y Change',
	'10Y Change',
	'Max Change',
	'Symbol',
	'Changes',
	'CIK',
	'Phone',
	'City',
	'State',
	'Zip',
	'Description',
	'Website',
	'Is ETF',
	'Is ADR',
	'Is Fund',
	'Name',
	'Changes Percentage',
	'Change',
	'Day Low',
	'Day High',
	'Year High',
	'Year Low',
	'Price Avg 50',
	'Price Avg 200',
	'Volume',
	'Avg Volume',
	'Open',
	'Previous Close',
	'EPS',
	'Earnings Announcement',
	'Shares Outstanding',
	'Timestamp'
]
